import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import NavbarLeft from "./../Components/NavbarLeft";
import { ReactComponent as QuestionMark } from "../../assets/navbar/QuestionMark.svg";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as HEcoA } from "../../assets/ecoscore/eco_h_a.svg";
import { ReactComponent as HEcoB } from "../../assets/ecoscore/eco_h_b.svg";
import { ReactComponent as HEcoC } from "../../assets/ecoscore/eco_h_c.svg";
import { ReactComponent as HEcoD } from "../../assets/ecoscore/eco_h_d.svg";
import { ReactComponent as HEcoE } from "../../assets/ecoscore/eco_h_e.svg";
import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";
import { ReactComponent as Cross } from "../../assets/analyse/Cross.svg";
import ScoreCircle from "../Components/ScoreCircle";
import AnalysisStep from "../Components/AnalysisStep";
import EcoScoreIndicatorsMenu from "../Components/EcoScoreIndicatorsMenu";
import "react-widgets/styles.css";
import "react-toastify/dist/ReactToastify.css";
// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchAnalysis, fetchLabels, fetchImpactIndicators } from "../../redux/actions/analysisActions";
import { calculEcoScore, setEcoScoreRemote, getEcoScore, setAllChecked, setAllCheckedLocal, clear_create_analysis_result, setExtractedData, setProductNameLocal, setProductName } from "../../redux/actions/analysisActions";
import ColumnDescrition from "./../Components/ColumnDescrition";
import ColumsTop from "../Components/ColumsTop";
import ColumnMenu from "../Components/ColumnMenu";
import ComponentLoading from "../../commonComponents/ComponentLoading";
import MainButton from "../../commonComponents/MainButton";
import { useLocation } from "react-router-dom";
import AnalysisStepRight from "../Components/AnalysisStepRight";
import Modal from "react-modal";

import { calculImpactStepResult, get_eco_score_icon } from "../../utils/utils.js";

const AnalysisPage = ({}) => {
  const location = useLocation();
  const [description, setDescription] = useState(0);
  const [savePopUp, setSavePopUp] = useState("");
  const [columnMenu, setColumnMenu] = useState("");
  const [columns, setColumns] = useState(["da32f256-618d-4bec-a8d9-205817788b26", "801c90a5-5b8d-312e-a924-ad9a275c754a"]);

  // REDUX ACTIONS
  const dispatch = useDispatch();
  const clear_create_analysis_result_rd = () => dispatch(clear_create_analysis_result());
  const fetchAnalysis_rd = (item) => dispatch(fetchAnalysis(item));
  const setExtractedData_rd = (item) => dispatch(setExtractedData(item));
  const fetchLabels_rd = () => dispatch(fetchLabels());
  const fetchImpactIndicators_rd = () => dispatch(fetchImpactIndicators());
  const setAllChecked_rd = (item) => dispatch(setAllChecked(item));
  const setAllCheckedLocal_rd = (item) => dispatch(setAllCheckedLocal(item));
  const setProductName_rd = (item) => dispatch(setProductName(item));
  const setProductNameLocal_rd = (item) => dispatch(setProductNameLocal(item));
  // REDUX STATES
  const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));
  const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual); //? state.analysis.analysis_data : null)
  const [isPersonnalize, setIsPersonnalize] = useState(location.state && (location.state.from === "AnalysisProduceChoice" ? true : false));
  const labels = useSelector((state) => (state.analysis.labels ? state.analysis.labels : null));
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));
  // ECO DATA
  const eco_packaging = useSelector((state) => (state.analysis.analysis_data && state.analysis.analysis_data.eco_packaging ? state.analysis.analysis_data.eco_packaging : []), shallowEqual);
  const palm_oil = useSelector((state) => (state.analysis.analysis_data && state.analysis.analysis_data.palm_oil ? state.analysis.analysis_data.palm_oil : null), shallowEqual);
  const product_labels = useSelector((state) => (state.analysis.analysis_data && state.analysis.analysis_data.labels ? state.analysis.analysis_data.labels : null), shallowEqual);

  const [totalScore, setTotalScore] = useState(null);
  const [ecoScore, setEcoScore] = useState(0);
  const [ecoScoreIndicatorsMenu, setEcoScoreIndicatorsMenu] = useState(false);
  const [hidden, setHidden] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const product_name = useSelector((state) => (state.analysis.analysis_data ? state.analysis.analysis_data.lca.lca_steps[0].ciqual_name.fr : null));
  // const [product_name, set_product_name] = useState(state.analysis_data.lca_steps[0].ciqual_name.fr);
  const [product_name_timer, set_product_name_timer] = useState(null);

  // GET ANALYSIS DATA
  useEffect(() => {
    console.log("---------------HERRRE", location.state);
    setExtractedData_rd(null);
    const fetchAnalysis_fn = async () => {
      await fetchAnalysis_rd(analysis_id);
    };
    if (!analysis_data) {
      fetchAnalysis_fn(analysis_id);
    } else if (location.state && !location.state.history) {
      fetchAnalysis_fn(analysis_id);
    } else if (location.state == null) {
      fetchAnalysis_fn(analysis_id);
    }

    // fetchAnalysis_fn();
    // }, [analysis_id]);
  }, [analysis_id]);

  // FETCH LABELS
  useEffect(() => {
    const fetchLabel_fn = async () => {
      await fetchLabels_rd();
    };
    if (!labels) {
      fetchLabel_fn();
    }
  }, []);

  // FETCH IMPACT INDICATORS
  useEffect(() => {
    const fetchImpactIndicators_fn = async () => {
      await fetchImpactIndicators_rd();
    };
    if (!impact_indicators) {
      fetchImpactIndicators_fn();
    }
  }, []);

  // TOTAL SCORE UPDATE
  useEffect(() => {
    const calc_fn = async () => {
      const eco_s = await calculImpactStepResult(analysis_data, "da32f256-618d-4bec-a8d9-205817788b26", 6);
      setTotalScore(eco_s);
    };
    if (analysis_data) {
      calc_fn();
    }
  }, [analysis_data, palm_oil, product_labels, eco_packaging]);

  // useEffect(() => {
  //   const calc_fn = async () => {
  //     const eco_s = await calculImpactStepResult(analysis_data, "da32f256-618d-4bec-a8d9-205817788b26", 6);
  //     setTotalScore(eco_s);
  //   };
  //   if (analysis_data) {

  //     calc_fn();
  //   }
  // }, []);

  // CHECKED (only when analysis open)
  useEffect(() => {
    // check very is checked
    if (analysis_data) {
      const checked = Object.values(analysis_data.lca.lca_steps).every((x) => {
        return (
          x.inputs &&
          Object.values(x.inputs).every((y) => {
            return y.checked;
          })
        );
      });

      let checked_wastes = true;
      Object.values(analysis_data.lca.lca_steps).map((x) => {
        return (
          x.outputs &&
          Object.values(x.outputs).map((y) => {
            if ((y.flow.category === "K_Wastes" || y.flow.category === "K_Food_Given") && !y.checked) {
              checked_wastes = false;
            }
          })
        );
      });
      if (checked && analysis_id && checked_wastes) {
        setAllChecked_rd({ analysis_id: analysis_id, status: "completed" });
        setAllCheckedLocal_rd({ analysis_id: analysis_id, status: "completed" });
      } else if (!checked && analysis_id) {
        setAllChecked_rd({ analysis_id: analysis_id, status: "onGoing" });
        setAllCheckedLocal_rd({ analysis_id: analysis_id, status: "onGoing" });
      }
    }
  }, []);

  // ECO SCORE UPDATE
  useEffect(() => {
    const calc_fn = async () => {
      await handleChangeEcoScore();
    };
    if (totalScore) {
      calc_fn();
    }
  }, [totalScore, palm_oil, product_labels, eco_packaging]);

  const handleChangeEcoScore = async () => {
    const product_labels_ids = product_labels ? Object.values(product_labels).map((x) => x.id) : [];
    let res_origins = [];
    if (analysis_data.ingredients) {
      Object.values(analysis_data.ingredients).map((x) => {
        // if is not ingredient
        if (x.unit) {
          return;
        } else {
          // look for K_Raw_Materials
          Object.values(x).map((y) => {
            if (y.category.name === "K_Raw_Materials") {
              // loop through inputs
              y.inputs &&
                Object.values(y.inputs).map((z) => {
                  let origin = {};
                  origin[z.origin] = parseFloat(z.amount * 100);
                  res_origins = [...res_origins, origin];
                });
            }
          });
        }
      });
    }
    let input_materiaux = [];
    Object.values(eco_packaging).map((x) => {
      let materiaux = {};
      materiaux[x.format.format] = x.material.materiaux;
      input_materiaux = [...input_materiaux, materiaux];
    });
    const item = {
      product_single_score: totalScore,
      input_labels: product_labels_ids,
      input_origins: JSON.stringify(res_origins),
      // input_materiaux: { Attache: "Aluminium (lourd > 60mm)" },
      input_materiaux: JSON.stringify(input_materiaux),
      huile_de_palme: palm_oil === "oui" ? true : false,
    };
    const eco_score = await calculEcoScore(item);
    await setEcoScoreRemote({ analysis_id: analysis_id, eco_score: eco_score, unique_score: totalScore });
    await setEcoScore(eco_score);
  };

  const handleOnProductNameChange = (e) => {
    // set_product_name(e.target.value)
    setProductNameLocal_rd(e.target.value)
    clearTimeout(product_name_timer);
    const timeoutId = setTimeout(() => {
      setProductName_rd(e.target.value)
    }, 2000);
    set_product_name_timer(timeoutId);
  }

  

  return (
    <>
      {analysis_data && impact_indicators && totalScore ? (
        <>
          {description !== 0 ? <ColumnDescrition description={description} setDescription={setDescription} columns={columns} setColumns={setColumns} /> : null}

          {columnMenu ? <ColumnMenu columns={columns} setColumnMenu={setColumnMenu} setColumns={setColumns} /> : null}

          <NavbarLeft currentPage={2} className="relative z-50" />
          <div className=" w-full fixed h-[70px] bg-white flex items-center border-[#BEC4CA] justify-evenly z-40">
            <div className="flex ml-16">
              <Link
                to={location.state && location.state.history ? "/AnalysisHistory" : "/AnalysisProduceChoice"}
                onClick={() => {
                  clear_create_analysis_result_rd();
                }}
              >
                <BackArrow />
              </Link>
            </div>

            <div className="ml-10 flex items-center  justify-between">
              <div className="h-[50px] w-60 flex items-center">
                <p className="font-Poppins-SemiBold inline w-[110px]">{"Analyser - "}</p>
                <input className="font-Poppins-SemiBold overflow-hidden text-ellipsis" value={product_name} onChange={handleOnProductNameChange}/>

              </div>
              <div className="flex items-center">
                {get_eco_score_icon(parseFloat(ecoScore))}
                <div className="h-[60px] w-[60px]">
                  <ScoreCircle score={ecoScore} />
                </div>
              </div>
            </div>

            <div className="flex">
              {/* <input className="w-[600px] mx-10 rounded-md bg-[#F8FAFB] font-PoppinsLignt text-sm h-[35px]" type="text" placeholder="recherche un produit, un procédé, une étape..." /> */}
              <div className="w-[600px] mx-10 rounded-md bg-white font-PoppinsLignt text-sm h-[35px]" />
            </div>

            <div className="h-[40px] w-[130px] flex justify-center" />
            {/* <UndoRedo /> */}
          </div>

          <div className="ml-[50px] mt-[70px] w-max">
            <div className="h-[95px] flex justify-start ml-[20px]">
              <div>
                <div className="h-[95px] flex items-center w-[563px]">
                  <button onClick={() => setEcoScoreIndicatorsMenu(true)} className="flex items-center justify-center bg-[#7E84A3] p-[10px] rounded-lg ml-[40px]">
                    <Plus height={20} fill={"white"} />
                    <p className="font-Poppins-SemiBold text-sm text-white pr-[4px]">Indicateurs spécifiques pour l'éco-score</p>
                  </button>
                </div>

                {ecoScoreIndicatorsMenu && <EcoScoreIndicatorsMenu setEcoScoreIndicatorsMenu={setEcoScoreIndicatorsMenu} />}

                <div>
                  <AnalysisStep
                    setHidden={setHidden}
                    hidden={hidden}
                    width={600}
                    columns={columns}
                    name={"Recettes"}
                    icon={"Recette"}
                    size={analysis_data.lca ? analysis_data.lca.lca_steps[4].inputs && analysis_data.lca.lca_steps[4].inputs.length : []}
                    data={analysis_data.lca ? analysis_data.lca.lca_steps[4] : null}
                    ingredients={analysis_data.ingredients ? analysis_data.ingredients : []}
                    totalScore={totalScore}
                    depth={0}
                  />
                  <AnalysisStep
                    setHidden={setHidden}
                    hidden={hidden}
                    width={600}
                    columns={columns}
                    name={"Packaging"}
                    icon={"Packaging"}
                    size={analysis_data.lca ? analysis_data.lca.lca_steps[3].inputs && analysis_data.lca.lca_steps[3].inputs.length : null}
                    data={analysis_data.lca ? analysis_data.lca.lca_steps[3] : null}
                    totalScore={totalScore}
                    depth={0}
                  />
                  <AnalysisStep
                    setHidden={setHidden}
                    hidden={hidden}
                    width={600}
                    columns={columns}
                    name={"Distribution"}
                    icon={"Distribution"}
                    size={analysis_data.lca ? analysis_data.lca.lca_steps[2].inputs && analysis_data.lca.lca_steps[2].inputs.length : null}
                    data={analysis_data.lca ? analysis_data.lca.lca_steps[2] : null}
                    totalScore={totalScore}
                    depth={0}
                  />
                  <AnalysisStep
                    setHidden={setHidden}
                    hidden={hidden}
                    width={600}
                    columns={columns}
                    name={"Vente au détail"}
                    icon={"Vente au détail"}
                    size={analysis_data.lca ? analysis_data.lca.lca_steps[1].inputs && analysis_data.lca.lca_steps[1].inputs.length : null}
                    data={analysis_data.lca ? analysis_data.lca.lca_steps[1] : null}
                    totalScore={totalScore}
                    depth={0}
                  />
                  <AnalysisStep
                    setHidden={setHidden}
                    hidden={hidden}
                    width={600}
                    columns={columns}
                    name={"Consommation"}
                    icon={"Consommation"}
                    size={analysis_data.lca ? analysis_data.lca.lca_steps[0].inputs && analysis_data.lca.lca_steps[0].inputs.length : null}
                    data={analysis_data.lca ? analysis_data.lca.lca_steps[0] : null}
                    totalScore={totalScore}
                    depth={0}
                  />
                </div>
              </div>

              {/* SCROLL RIGHT */}
              <div className=" overflow-x-scroll w-[767px] h-max">
                <div className={`h-[95px] w-max flex border-y-[1px] border-t-[1px] boder-[#BEC4CA] bg-white`}>
                  <ColumsTop columns={columns} setDescription={setDescription} />
                </div>

                <div className="flex">
                  <div>
                    <AnalysisStepRight
                      hidden={hidden}
                      width={600}
                      columns={columns}
                      name={"Recettes"}
                      icon={"Recette"}
                      size={analysis_data.lca ? analysis_data.lca.lca_steps[4].inputs && analysis_data.lca.lca_steps[4].inputs.length : []}
                      data={analysis_data.lca ? analysis_data.lca.lca_steps[4] : null}
                      ingredients={analysis_data.ingredients ? analysis_data.ingredients : null}
                      totalScore={totalScore}
                      depth={0}
                    />
                    <AnalysisStepRight
                      hidden={hidden}
                      width={600}
                      columns={columns}
                      name={"Packaging"}
                      icon={"Packaging"}
                      size={analysis_data.lca ? analysis_data.lca.lca_steps[3].inputs && analysis_data.lca.lca_steps[3].inputs.length : null}
                      data={analysis_data.lca ? analysis_data.lca.lca_steps[3] : null}
                      totalScore={totalScore}
                      depth={0}
                    />
                    <AnalysisStepRight
                      hidden={hidden}
                      width={600}
                      columns={columns}
                      name={"Distribution"}
                      icon={"Distribution"}
                      size={analysis_data.lca ? analysis_data.lca.lca_steps[2].inputs && analysis_data.lca.lca_steps[2].inputs.length : null}
                      data={analysis_data.lca ? analysis_data.lca.lca_steps[2] : null}
                      totalScore={totalScore}
                      depth={0}
                    />
                    <AnalysisStepRight
                      hidden={hidden}
                      width={600}
                      columns={columns}
                      name={"Vente au détail"}
                      icon={"Vente au détail"}
                      size={analysis_data.lca ? analysis_data.lca.lca_steps[1].inputs && analysis_data.lca.lca_steps[1].inputs.length : null}
                      data={analysis_data.lca ? analysis_data.lca.lca_steps[1] : null}
                      totalScore={totalScore}
                      depth={0}
                    />
                    <AnalysisStepRight
                      hidden={hidden}
                      width={600}
                      columns={columns}
                      name={"Consommation"}
                      icon={"Consommation"}
                      size={analysis_data.lca ? analysis_data.lca.lca_steps[0].inputs && analysis_data.lca.lca_steps[0].inputs.length : null}
                      data={analysis_data.lca ? analysis_data.lca.lca_steps[0] : null}
                      totalScore={totalScore}
                      depth={0}
                    />
                  </div>

                  <div className={`w-[100px] px-[20px] h-screen bg-[#F3F5F7] flex justify-center items-center`}>
                    <button
                      onClick={() => {
                        setColumnMenu(1);
                      }}
                    >
                      <Plus />
                    </button>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>
            <div></div>
            <div className="w-full h-[50px]" />
          </div>

          <Modal
            isOpen={isPersonnalize}
            onBackdropPress={() => setIsPersonnalize(false)}
            style={{
              content: {
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 330,
                width: 580,
                borderRadius: 20,
                borderWidth: 0,
                boxShadow: "0px 0px 2px #9E9E9E",
              },
            }}
          >
            <div className=" h-full grid justify-items-center">
              <p className="font-Poppins-SemiBold text-4xl flex text-center mt-[40px]">Ajustez les étapes du cycle de vie</p>
              <p className="font-Poppins-Light text-sm flex text-center mt-[0px]">Afin de vous rapprocher de votre produit, ajustez les informations dans chaque étape de cycle de vie.</p>
              <div className="cursor-pointer absolute right-2">
                <Cross height={20} onClick={() => setIsPersonnalize(false)} />
              </div>
              <div class="flex items-center w-[200px] justify-center h-[40px] mt-[10px]">
                <MainButton
                  disabled={true}
                  callback={async () => {
                    setIsPersonnalize(false);
                  }}
                  title={"C'est compris !"}
                  styleWind={"text-xs px-[10px]"}
                />
              </div>
            </div>
          </Modal>
        </>
      ) : (
        <>
          <ComponentLoading height={35} style={"h-full flex items-center justify-center"} />
        </>
      )}
    </>
  );
};

export default AnalysisPage;

// const mapStateToProps = state => ({
//   analysis_data: state.analysis.analysis_data,
//   loading: state.analysis.loading
// })

// export default connect(mapStateToProps)(AnalysisPage)
